import React, { useEffect, useRef } from 'react';

// Dialog del portale, per contenuti che una swal non regge (tabelle, elenchi).
// Riusa gli stili .modal-overlay / .modal-content / .modal-title già presenti in Header.css.
//
// Pensato per TABLET: si chiude toccando fuori o con Esc, il bottone di chiusura è a dimensione
// touch, e il corpo scrolla dentro il modal (non la pagina sotto) così la tabella resta leggibile
// anche con molte righe.
const PkgModal = ({ title, subtitle, onClose, children }) => {
    // La chiusura deve seguire un click COMINCIATO sullo sfondo. Il `click` scatta sull'antenato
    // comune di premuta e rilascio: partendo da dentro un campo e rilasciando fuori (selezione di
    // testo, trascinamento del dito, tendina nativa di un input date) il target diventa l'overlay e
    // il dialog si chiudeva buttando via quello che era stato compilato.
    const pressedOnOverlay = useRef(false);
    // Esc chiude: su tablet con tastiera collegata è l'unico modo rapido oltre al tocco fuori.
    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', onKey);
        // Blocca lo scroll della pagina sotto: senza, il tocco trascina l'elenco dietro il modal.
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', onKey);
            document.body.style.overflow = prev;
        };
    }, [onClose]);

    return (
        // Chiude solo se premuta E rilascio sono sullo sfondo. Lo stopPropagation sul contenuto da
        // solo non basta: nel caso premuta-dentro/rilascio-fuori il click non nasce dal contenuto.
        <div
            className="modal-overlay"
            onMouseDown={e => { pressedOnOverlay.current = e.target === e.currentTarget; }}
            onClick={e => {
                if (e.target === e.currentTarget && pressedOnOverlay.current) { onClose(); }
                pressedOnOverlay.current = false;
            }}
        >
            <div className="modal-content modal-content-wide" onClick={e => e.stopPropagation()}>
                <h3 className="modal-title">{title}</h3>
                {subtitle ? <div className="pkg-modal-subtitle">{subtitle}</div> : null}
                {children}
                <div className="pkg-actions-right">
                    <button className="blue_butt" onClick={onClose}>Chiudi</button>
                </div>
            </div>
        </div>
    );
};

export default PkgModal;
